import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { UpdateTrashBinBusinessSuccessResponseInfo } from '@/coreInfrastructureModule/axios/generated/trashBinManage/api';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { ITrashBinRepository } from '@/coreInfrastructureModule/interfaces/ITrashBinRepository';

/**
 * 関連取引の削除(論理削除)を行うユースケース
 */
export class DeleteDeletionBaseBusinessUseCase {
  private repository: ITrashBinRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: ITrashBinRepository) {
    this.repository = repository;
  }

  /**
   * 指定された取引情報を論理削除する
   * @param businessIds - 取引ID
   */
  public async Execute(businessIds: string[]): Promise<INetworkResult<UpdateTrashBinBusinessSuccessResponseInfo, IError>> {
    try {
      const deleteBaseBusinessResponseInfo = {
        updateTrashBinBusinessIdArray: businessIds,
        isTrashFlag: true, // 取引を論理削除するためにフラグをtrueにする
      };
      const response = await this.repository.updateTrashBinBusiness(deleteBaseBusinessResponseInfo);
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: response.status.data,
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
